import { RiskLevel } from "@/model/RiskLevel";
import LambethLogo from "@/assets/regions/Lb_lambeth_logo.svg";
import { DefaultLower } from "@/model/DefaultBanners";
const LambethBanner = {
    rawCopy: "For alcohol advice and support in Lambeth, call Lorraine Hewitt House on " +
        "0203 228 1500 or find out more <u>here</u>",
    logoLink: "https://www.lambeth-drug-alcohol.co.uk/"
};
const IncreasingBanner = {
    rawCopy: `Click here to <u>book a free online appointment</u> with a DrinkCoach alcohol specialist. Up to 6 free sessions for Lambeth residents.`,
    logoLink: "https://bookdrinkcoach.as.me/lambeth"
};
const HigherBanner = {
    rawCopy: `To help you cut down, Lambeth residents can have up to 6 free sessions with a DrinkCoach alcohol specialist. <u>Click here to book now</u>.`,
    logoLink: "https://bookdrinkcoach.as.me/lambeth"
};
export default {
    name: "Lambeth",
    logo: {
        file: LambethLogo,
        width: 235,
        height: 83
    },
    hasFreeAppointments: true,
    showServiceInfoOnResultsSummaryPage: true,
    bannerInfo: {
        default: LambethBanner,
        [RiskLevel.Lower]: DefaultLower,
        [RiskLevel.Increasing]: IncreasingBanner,
        [RiskLevel.Higher]: HigherBanner,
        [RiskLevel.High]: LambethBanner
    },
    regions: [
        "Brixton Acre Lane",
        "Brixton North",
        "Brixton Rush Common",
        "Brixton Windrush",
        "Clapham Common & Abbeville",
        "Clapham East",
        "Clapham Park",
        "Clapham Town",
        "Gipsy Hill",
        "Herne Hill & Loughborough Junction",
        "Kennington",
        "Knights Hill",
        "Myatt Fields",
        "Oval",
        "St Martins",
        "Stockwell East",
        "Stockwell West & Larkhall",
        "Streatham St Leonards",
        "Streatham Wells",
        "Streatham Common & Vale",
        "Streatham Hill East",
        "Streatham Hill West & Thornton",
        "Vauxhall",
        "Waterloo & South Bank",
        "West Dulwich"
    ],
    clinics: [
        {
            name: "Lorraine Hewitt House",
            location: { lat: 51.4620365, lng: -0.11717529999998533 },
            isPrimaryProvider: true,
            alwaysShowInResults: true,
            description: "Visit the walk-in service at ${name}",
            address: "12/14 Brighton Terrace, Brixton, SW9 8DG",
            phone: ["0203 228 1500"],
            times: [
                {
                    title: "Drop-in service:",
                    times: {
                        monday: [{ start: 900, end: 1645 }],
                        tuesday: [{ start: 900, end: 1345 }],
                        wednesday: [{ start: 900, end: 1645 }],
                        thursday: [{ start: 900, end: 1645 }],
                        friday: [{ start: 900, end: 1645 }]
                    }
                }
            ],
            website: "https://www.lambeth-drug-alcohol.co.uk/"
        },
        {
            name: "Beckett House",
            address: "Beckett House, Grantham Road, SW9 9DL",
            location: { lat: 51.4695805, lng: -0.12379320000002281 },
            phone: ["020 7738 7030"],
            website: "https://www.becketthousepractice.nhs.uk/",
            times: [
                {
                    info: "(Appointment)",
                    times: {
                        monday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        tuesday: [
                            {
                                start: 800,
                                end: 1945
                            }
                        ],
                        wednesday: [
                            {
                                start: 800,
                                end: 1945
                            }
                        ],
                        thursday: [
                            {
                                start: 800,
                                end: 1945
                            }
                        ],
                        friday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ]
                    }
                }
            ]
        },
        {
            name: "Binfield Road",
            address: "1 Binfield Rd, SW4 6TB",
            location: { lat: 51.47446979999999, lng: -0.12563139999997475 },
            phone: ["02076221424"],
            website: "http://www.binfieldroadsurgery.co.uk/",
            times: [
                {
                    info: "(Appointment)",
                    times: {
                        monday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        tuesday: [
                            {
                                start: 800,
                                end: 1900
                            }
                        ],
                        wednesday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        thursday: [
                            {
                                start: 800,
                                end: 1900
                            }
                        ],
                        friday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ]
                    }
                }
            ]
        },
        {
            name: "Hurley Clinic ",
            address: "Ebenezer House, Kennington Lane, SE11 4HJ",
            location: { lat: 51.4906876, lng: -0.1070531000000301 },
            phone: ["020 7735 7918"],
            website: "http://hurleyclinic.co.uk/",
            times: [
                {
                    info: "(Appointment)",
                    times: {
                        monday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        tuesday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        wednesday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        thursday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        friday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ]
                    }
                }
            ]
        },
        {
            name: "Lambeth Walk Group Practice",
            location: { lat: 51.495634, lng: -0.11261430000001837 },
            address: "5 Lambeth Walk, SE11 6SP",
            phone: ["02077354412"],
            website: "http://lambethwalkgp.co.uk/",
            times: [
                {
                    info: "(Appointment)",
                    times: {
                        monday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        tuesday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        wednesday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        thursday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        friday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ]
                    }
                }
            ]
        },
        {
            name: "Mawbey Group Practice",
            location: { lat: 51.4794085, lng: -0.12494229999992967 },
            address: "Mawbey Brough Health Centre, 39 Wilcox Close, SW8 2UD",
            phone: ["020 7411 5720"],
            website: "http://www.mawbeygp.nhs.uk/",
            times: [
                {
                    info: "(Appointment)",
                    times: {
                        monday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        tuesday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        wednesday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        thursday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        friday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ]
                    }
                }
            ]
        },
        {
            name: "Riverside Medical Practice (Hurley)",
            location: { lat: 51.4855344, lng: -0.12586899999996604 },
            address: "Flagstaff House, St Georges Wharf, Wandsworth Road, SW8 2JW",
            phone: ["020 3049 4500"],
            website: "http://riversidemedicalcentre.com/",
            times: [
                {
                    info: "(Appointment)",
                    times: {
                        monday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        tuesday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        wednesday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        thursday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        friday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ]
                    }
                }
            ]
        },
        {
            name: "South Lambeth Road",
            location: { lat: 51.4770778, lng: -0.12367080000001351 },
            address: "1 Selway House, 272 South Lambeth Road, SW8 1UL",
            phone: ["020 7622 1923"],
            website: "http://www.southlambethroadpractice.co.uk/",
            times: [
                {
                    info: "(Appointment)",
                    times: {
                        monday: [
                            {
                                start: 800,
                                end: 2000
                            }
                        ],
                        tuesday: [
                            {
                                start: 800,
                                end: 2000
                            }
                        ],
                        wednesday: [
                            {
                                start: 800,
                                end: 2000
                            }
                        ],
                        thursday: [
                            {
                                start: 800,
                                end: 2000
                            }
                        ],
                        friday: [
                            {
                                start: 800,
                                end: 2000
                            }
                        ]
                    }
                }
            ]
        },
        {
            name: "Springfield Medical Centre",
            location: { lat: 51.4706357, lng: -0.13308710000001156 },
            address: "110 Union Road, Stockwell, SW8 2SH",
            phone: ["02030494600"],
            website: "http://www.springfieldmedicalcentre.co.uk/",
            times: [
                {
                    info: "(Appointment)",
                    times: {
                        monday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        tuesday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        wednesday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        thursday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        friday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ]
                    }
                }
            ]
        },
        {
            name: "Stockwell Group Practice",
            location: { lat: 51.4680189, lng: -0.11757379999994555 },
            address: "107 Stockwell Road, SW9 9TJ",
            phone: ["02072743223"],
            website: "http://www.stockwellgrouppractice.co.uk/",
            times: [
                {
                    info: "(Appointment)",
                    times: {
                        monday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        tuesday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        wednesday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        thursday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        friday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ]
                    }
                }
            ]
        },
        {
            name: "The Grantham Centre",
            location: { lat: 51.4695805, lng: -0.12379320000002281 },
            address: "Beckett House, Grantham Road, SW9 9DL",
            phone: ["02077336191"],
            website: "https://www.thegp.london/",
            times: [
                {
                    info: "(Appointment)",
                    times: {
                        monday: [
                            {
                                start: 800,
                                end: 1900
                            }
                        ],
                        tuesday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        wednesday: [
                            {
                                start: 800,
                                end: 1900
                            }
                        ],
                        thursday: [
                            {
                                start: 800,
                                end: 1900
                            }
                        ],
                        friday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ]
                    }
                }
            ]
        },
        {
            name: "Vauxhall Surgery",
            location: { lat: 51.48989719999999, lng: -0.11893850000001294 },
            address: "8 Jonathan Street, SE11 5NH",
            phone: ["020277351971"],
            website: "http://vauxhallsurgery.co.uk/",
            times: [
                {
                    info: "(Appointment)",
                    times: {
                        monday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        tuesday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        wednesday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        thursday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        friday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ]
                    }
                }
            ]
        },
        {
            name: "Waterloo Health Centre",
            location: { lat: 51.5002575, lng: -0.11366680000003271 },
            address: "5 Lower Marsh, SE1 7RJ",
            phone: ["02079284049"],
            website: "http://www.waterloohealth.co.uk/",
            times: [
                {
                    info: "(Appointment)",
                    times: {
                        monday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        tuesday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        wednesday: [
                            {
                                start: 800,
                                end: 2000
                            }
                        ],
                        thursday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        friday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ]
                    }
                }
            ]
        },
        {
            name: "Akerman Medical Practice",
            location: { lat: 51.4757701, lng: -0.10523910000006254 },
            address: "2nd Floor, Akerman Health Centre, 60 Patmos Street, SW9 6AF",
            phone: ["020 3049 6500"],
            website: "https://www.akermanmedicalpractice.com/",
            times: [
                {
                    info: "(Appointment)",
                    times: {
                        monday: [
                            {
                                start: 800,
                                end: 1930
                            }
                        ],
                        tuesday: [
                            {
                                start: 800,
                                end: 1930
                            }
                        ],
                        wednesday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        thursday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ]
                    }
                }
            ]
        },
        {
            name: "Brixton Water Lane",
            location: { lat: 51.4551278, lng: -0.11203599999998914 },
            address: "48 Brixton Water Lane, SW2 1QE",
            phone: ["02077379449"],
            website: ""
        },
        {
            name: "Brockwell Park",
            location: { lat: 51.4486961, lng: -0.10156470000003992 },
            address: "117 Norwood Road, SE24 9AE",
            phone: ["02086785400"],
            website: "http://www.brockwellparksurgery.com/",
            times: [
                {
                    info: "(Appointment)",
                    times: {
                        monday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        tuesday: [
                            {
                                start: 800,
                                end: 1930
                            }
                        ],
                        wednesday: [
                            {
                                start: 800,
                                end: 2000
                            }
                        ],
                        thursday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        friday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ]
                    }
                }
            ]
        },
        {
            name: "North Wood Group Practice",
            location: { lat: 51.42261449999999, lng: -0.1008288000000448 },
            address: "61 Crown Dale, SE19 3NY",
            phone: ["020 8670 2414"],
            website: "https://northwoodgrouppractice.co.uk/",
            times: [
                {
                    info: "(Appointment)",
                    times: {
                        monday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        tuesday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        wednesday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        thursday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        friday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ]
                    }
                }
            ]
        },
        {
            name: "",
            address: "4 Hardel Rise, Tulse Hill, SW2 3DX",
            location: { lat: 51.4407315, lng: -0.10847560000001977 },
            phone: ["020 8671 3448"],
            website: "https://northwoodgrouppractice.co.uk/",
            times: [
                {
                    info: "(Appointment)",
                    times: {
                        monday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        tuesday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        wednesday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        thursday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        friday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ]
                    }
                }
            ]
        },
        {
            name: "Herne Hill Group Practice",
            location: { lat: 51.4555906, lng: -0.09920720000002348 },
            address: "74 Herne Hill, SE24 9QP",
            phone: ["02072743314"],
            website: "http://hernehillgp.nhs.uk/",
            times: [
                {
                    info: "(Appointment)",
                    times: {
                        monday: [
                            {
                                start: 800,
                                end: 1900
                            }
                        ],
                        tuesday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        wednesday: [
                            {
                                start: 800,
                                end: 1930
                            }
                        ],
                        thursday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        friday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ]
                    }
                }
            ]
        },
        {
            name: "Minet Green Health Practice",
            location: { lat: 51.4757701, lng: -0.10523910000006254 },
            address: "1st Floor, Akerman Health Centre, 60 Patmos Street, SW9 6AF",
            phone: ["0203 0496690"],
            website: "https://www.minetgreenhealthpractice.co.uk/",
            times: [
                {
                    info: "(Appointment)",
                    times: {
                        monday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        tuesday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        wednesday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        thursday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        friday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ]
                    }
                }
            ]
        },
        {
            name: "Knights Hill",
            location: { lat: 51.4327614, lng: -0.1059659999999667 },
            address: "25 Devane Way, SE27 0DF",
            phone: ["020 3141 0700"],
            website: "http://www.knightshillsurgery.nhs.uk/",
            times: [
                {
                    info: "(Appointment)",
                    times: {
                        monday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        tuesday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        wednesday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        thursday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ]
                    }
                }
            ]
        },
        {
            name: "Vassall Medical Centre",
            location: { lat: 51.4775456, lng: -0.10869890000003579 },
            address: "89 Vassell Road, SW9 6NA",
            phone: ["02077933100"],
            website: "http://www.vassallmedicalcentre.co.uk/",
            times: [
                {
                    info: "(Appointment)",
                    times: {
                        monday: [
                            {
                                start: 700,
                                end: 1830
                            }
                        ],
                        tuesday: [
                            {
                                start: 700,
                                end: 1830
                            }
                        ],
                        wednesday: [
                            {
                                start: 700,
                                end: 1830
                            }
                        ],
                        thursday: [
                            {
                                start: 700,
                                end: 1830
                            }
                        ],
                        friday: [
                            {
                                start: 700,
                                end: 1830
                            }
                        ]
                    }
                }
            ]
        },
        {
            name: "Paxton Green",
            location: { lat: 51.4276251, lng: -0.08606480000003103 },
            address: "1 Alleyn Road, SE21 8AU",
            phone: ["020 8670 6878"],
            website: "https://paxtongreen.uk/",
            times: [
                {
                    info: "(Appointment)",
                    times: {
                        monday: [
                            {
                                start: 800,
                                end: 1900
                            }
                        ],
                        tuesday: [
                            {
                                start: 800,
                                end: 1900
                            }
                        ],
                        wednesday: [
                            {
                                start: 800,
                                end: 1900
                            }
                        ],
                        thursday: [
                            {
                                start: 800,
                                end: 1900
                            }
                        ],
                        friday: [
                            {
                                start: 800,
                                end: 1900
                            }
                        ]
                    }
                }
            ]
        },
        {
            name: "The Corner Surgery",
            location: { lat: 51.4696124, lng: -0.09607930000004217 },
            address: "99 Coldharbour Lane, SE5 9NS",
            phone: ["020 7274 4507"],
            website: "http://www.thecornersurgery.nhs.uk/",
            times: [
                {
                    info: "(Appointment)",
                    times: {
                        monday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        tuesday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        wednesday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        thursday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ],
                        friday: [
                            {
                                start: 800,
                                end: 1830
                            }
                        ]
                    }
                }
            ]
        },
        {
            name: "The Deerbrook",
            location: { lat: 51.43834320000001, lng: -0.10629859999994551 },
            address: "216 Norwood Road, SE27 9AW",
            phone: ["02030496370"],
            website: "http://www.thedeerbrooksurgery.nhs.uk/",
            times: [
                {
                    info: "(Appointment)",
                    times: {
                        monday: [
                            {
                                start: 830,
                                end: 1800
                            }
                        ],
                        tuesday: [
                            {
                                start: 830,
                                end: 1800
                            }
                        ],
                        wednesday: [
                            {
                                start: 830,
                                end: 1945
                            }
                        ],
                        thursday: [
                            {
                                start: 830,
                                end: 1800
                            }
                        ],
                        friday: [
                            {
                                start: 830,
                                end: 1800
                            }
                        ]
                    }
                }
            ]
        },
        {
            name: "The Norwood Surgery",
            location: { lat: 51.4359262, lng: -0.10404809999999998 },
            address: "483 Norwood Road, SE27 9DJ",
            phone: ["020 8670 1000"],
            website: "www.thenorwoodsurgery.co.uk"
        },
        {
            name: "The Rosendale Road Surgery",
            location: { lat: 51.4372056, lng: -0.09482669999999871 },
            address: "103a Rosendale Road, SE21 8EZ",
            phone: ["020 8761 8070"],
            website: "https://theodhc.co.uk/"
        },
        {
            name: "Brixton Hill Group Practice",
            location: { lat: 51.4523441, lng: -0.12033440000004703 },
            address: "22 Raleigh Gardens, SW2 1AE",
            phone: ["02086746376"],
            website: "http://www.brixtonhillgp.co.uk/"
        },
        {
            name: "Clapham Family Practice",
            location: { lat: 51.462981, lng: -0.1332655999999588 },
            address: "89 Clapham High Street, SW4 7DB",
            phone: ["02030496600"],
            website: "http://www.claphamfamilypractice.com"
        },
        {
            name: "Clapham Park Group Practice",
            location: { lat: 51.4519187, lng: -0.13517019999994773 },
            address: "72 Clarence Avenue, SW4 8JP",
            phone: ["02086785420"],
            website: "https://www.claphamparkgp.com/"
        },
        {
            name: "Dr Curran & Partners",
            location: { lat: 51.4653827, lng: -0.13607060000003912 },
            address: "86 Clapham Manor Street, SW4 6EB",
            phone: ["02074116866"],
            website: "https://www.claphamhealth.nhs.uk/home/"
        },
        {
            name: "Dr Masterton & Partners",
            location: { lat: 51.4305989, lng: -0.1302338000000418 },
            address: "2 Prentis Road, SW16 1XU",
            phone: ["02086965508"],
            website: "http://www.drmastertonandpartners.nhs.uk/"
        },
        {
            name: "Edith Cavell (AT Medics)",
            location: { lat: 51.4410976, lng: -0.12460409999994226 },
            address: "41a-c Streatham Hill, SW2 4TP",
            phone: ["02030495900"],
            website: "https://www.streathamgp.co.uk/"
        },
        {
            name: "Hetherington Group Practice",
            location: { lat: 51.4612329, lng: -0.12827390000006744 },
            address: "18 Hetherington Road, SW4 7NU",
            phone: ["02072744220"],
            website: "http://www.hetheringtongp.co.uk/"
        },
        {
            name: "Hetherington at Pavilion",
            location: { lat: 51.461668, lng: -0.11639439999999013 },
            address: "9 Brighton Terrace, SW9 8DJ",
            phone: ["02072749252"],
            website: "http://www.pavilionmedicalcentre.co.uk/"
        },
        {
            name: "Palace Road",
            location: { lat: 51.4437963, lng: -0.12060369999994691 },
            address: "3 Palace Road, SW2 3DY",
            phone: ["02086742083"],
            website: "https://www.palaceroadsurgery.co.uk/"
        },
        {
            name: "Streatham Common Group Practice",
            location: { lat: 51.4163499, lng: -0.12858800000003612 },
            address: "St Andrew's Hall, Guildersfield Road, SW16 5LS",
            phone: ["02030495470"],
            website: "https://www.streathamcommonpractice.co.uk/"
        },
        {
            name: "Streatham High (AT Medics)",
            location: { lat: 51.4326765, lng: -0.12793590000001132 },
            address: "2-8 Gracefield Gardens, SW16 2ST",
            phone: ["02030494850"],
            website: "https://www.streathamgp.co.uk/"
        },
        {
            name: "Streatham Hill Group Practice",
            location: { lat: 51.43725999999999, lng: -0.12626699999998436 },
            address: "6 Leigham Court Road, SW16 2PG",
            phone: ["02038290800"],
            website: "http://www.shgp.co.uk/"
        },
        {
            name: "Streatham Place Surgery",
            location: { lat: 51.4463744, lng: -0.1266180999999733 },
            address: "26-28 Streatham Place, SW2 4QY",
            phone: ["02086748500"],
            website: "https://www.streathamgp.co.uk/"
        },
        {
            name: "The Exchange Surgery",
            location: { lat: 51.4326765, lng: -0.12793590000001132 },
            address: "2-8 Gracefield Gardens, SW16 2ST",
            phone: ["02030494888"],
            website: "https://www.streathamgp.co.uk/"
        },
        {
            name: "The Vale Surgery",
            location: { lat: 51.4173449, lng: -0.13687400000003436 },
            address: "Streatham Vale, SW16 5SE",
            phone: ["02086797536"],
            website: "https://www.thevalesurgery.co.uk/"
        },
        {
            name: "Valley Road",
            location: { lat: 51.4286213, lng: -0.1193934000000354 },
            address: "139 Valley Road, SW16 2XT",
            phone: ["02087692566"],
            website: "https://www.nhs.uk/Services/GP/Overview/DefaultView.aspx?id=36453"
        },
        {
            name: "Grafton Square Surgery",
            location: { lat: 51.46463800000001, lng: -0.13974949999999353 },
            address: "8b Grafton Square, SW4 0DE",
            phone: ["02076225642"],
            website: "https://www.graftonsquaresurgery.nhs.uk/"
        },
        {
            name: "Sandmere Road Practice",
            location: { lat: 51.4626172, lng: -0.12828609999996843 },
            address: "10 Sandmere Road, SW4 7QJ",
            phone: ["2072746366"],
            website: "https://www.nhs.uk/Services/GP/Overview/DefaultView.aspx?id=38996"
        },
        {
            name: "DrinkCoach Online Coaching Service",
            alwaysShowFirst: true,
            showAtRiskLevel: [RiskLevel.Higher, RiskLevel.Increasing],
            tagline: "Access up to 6 free sessions with DrinkCoach.<br><a href='https://bookdrinkcoach.as.me/lambeth' target='_blank'>Book now</a>",
            alwaysShowInResults: true,
            website: "https://drinkcoach.org.uk/book-online-appointment"
        }
        //
    ]
};
//# sourceMappingURL=Lambeth.js.map